<template>
    <b-card class="coach-reminders-cards">
        <h3>
            {{reminder.title}}
        </h3>
        <div class="row coach-reminders-cards-row">
            <div class="col-8 coach-reminders-cards-infos">
                <p>
                    {{reminder.ou}}
                </p>
                <p>
                    {{reminder.subtitle}} à {{ moment(meeting.dateheure.date).format('HH:mm') }}
                </p>
            </div>
            <div class="col-4 coach-reminders-cards-button">
                <b-btn
                        :to="reminder.link"
                        class="coach-reminders-cards-btn"
                >
                    <template v-if="user.id === meetingId">
                        Voir
                    </template>
                    <template v-else>
                        Gérer la séance
                    </template>
                </b-btn>
            </div>
        </div>
    </b-card>
</template>
<script>
    import moment from 'moment'

    export default {
        name: 'home-bottom-reminder',
        props: {
            reminder: Object
        },
        data: () => ({
            moment
        }),
        async mounted() {
            await this.$store.dispatch('base/meeting/detail', {meetingId: this.reminder.link.params.id})
        },
        computed: {
            user() {
                return this.$store.state.base.account.information
            },
            meeting() {
                return this.$store.state.base.meeting.list[this.reminder.link.params.id] || {}
            },
            meetingId() {
                return this.meeting.id
            }
        }
    }
</script>
